export const ANIMATION_DURATION = 2000
